import "core-js/modules/es6.object.freeze";
export default Object.freeze({
  EXPO: 'cubic-bezier(0.19, 1, 0.22, 1)',
  SINE: 'cubic-bezier(0.39, 0.58, 0.57, 1)'
});